export default __webpack_public_path__ + "static/media/course_main.0df177e2.png";